module.exports = __webpack_public_path__ + "static/media/32.67ae4d75.jpg";